import {
    errorMessages
} from './utils';

const geolocate = (geolocateEl, searchInput, geocoder, setIsLoading) => {
    if (!navigator.geolocation) {
        return;
    }

    const geolocateBtn = geolocateEl.querySelector('[role="button"]');

    geolocateEl.removeAttribute('hidden');

    const setPosition = (position) => {
        geocoder.geocode({
            location: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            }
        }).then((res) => {
            if (!res.results.length) {
                throw new Error(ERROR);
            }
            const {
                results: [{
                    formatted_address
                }]
            } = res;
            searchInput.value = formatted_address;
            searchInput.dispatchEvent(new Event('input'));
        }).catch(() => {
            throw new Error(errorMessages.GEOLOCATION_ERROR);
        }).finally(() => setIsLoading(false));
    };

    geolocateBtn.addEventListener('click', () => {
        setIsLoading(true);
        navigator.geolocation.getCurrentPosition(setPosition);
    });
};

export default geolocate;
